import "./App.css";
import "./Report";
import { Box, Grommet } from "grommet";
import Report from "./Report";
import Report_template_2 from "./Report_template_2";
import { getGoogleMaps } from "./utils/Utils";
import React, { Component } from "react";
import { ApolloProvider } from "@apollo/react-hooks";
const ApolloClient = require("apollo-boost").ApolloClient;
const createHttpLink = require("apollo-link-http").createHttpLink;
const InMemoryCache = require("apollo-cache-inmemory").InMemoryCache;
const gql = require("apollo-boost").gql;

const client = new ApolloClient({
  link: createHttpLink({
    uri: "https://hasura-dev.ioloc.co.za/v1/graphql",
    fetch: fetch,
    headers: {
      "x-hasura-admin-secret": "ZbhaLxPQY56w5rio8F1zf7hDmqJSYUUc",
    },
  }),
  cache: new InMemoryCache(),
});

export class App extends Component {


  state = {
    shiftId: 0,
    lobi: 2
  };





  componentDidMount = () => {
    let googleMapPromise = getGoogleMaps();
    if (!window.google) {
      //console.log("!window.google");
      Promise.all([googleMapPromise]).then((values) => {
        // eslint-disable-next-line
        let google = values[0];
        //this.getShiftData();
        //console.log(values);
      });
    } else {
      console.log("window.google");
      //this.getShiftData();
    }
    console.log(window.location.href);
    const url = window.location.href;
    const urlArray = url.split("?");

    let runningLocally = false;
    console.log("Output: : App -> componentDidMount -> urlArray", urlArray);
    if (urlArray[0] === "http://localhost:3000/") {
      runningLocally = true;
      console.log(
        "Output: : App -> componentDidMount -> runningLocally",
        runningLocally
      );
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////INPUT PARAMETER MAPPING//////////////////////////////////////////
    //////////////////////////////////////////////////////////////////////////////////////////////////////////


    const reportTemplateId = urlArray[1];
    // Variable initialisation
    let shiftId = ""
    let shiftStartDate = ""
    let buildingId = ""
    let lobi = ""

    // logic to set parameters from URL String depending on reportTemplateId
    if (reportTemplateId == 1) {
      shiftId = urlArray[2];
      //shiftStartDate = urlArray[3];
      lobi = urlArray[3] == "lobi" ? 1 : 2;
    }
    else if (reportTemplateId == 2) {
      buildingId = urlArray[2];
    } else { console.log("template ID not found") }

//////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////INPUT PARAMETER MAPPING//////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////


    console.log(
      "Output: : App -> componentDidMount -> shiftStartDate",
      shiftStartDate
    );
    console.log("Output: : App -> componentDidMount -> shiftId", shiftId);
    const newState = {
      ...this.state,
      shiftId: shiftId,
      lobi: lobi,
      runningLocally: runningLocally,
      shiftStartDate: shiftStartDate,
      buildingId: buildingId,
      template: reportTemplateId,
    };
    this.setState(newState);
  };

  render() {

    console.log("The function gets here")


    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////////////////////TESTING THE CLIENT//////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    /**
        client
          .query({
            query: gql`
    query MyQuery {
      Incident(where: {Shift_Gaurd: {Shift: {Building: {Id: {_eq: "178ffda8-f1a2-4fce-878b-24a191138269"}}}, Gaurd: {GaurdFirstName: {_neq: "Lobi"}}}, Resolved: {_eq: false}}) {
        Description
        EndDateTime
        Id
        ImageUrl
        Lat
        Long
        Resolution
        Resolved
        ShiftGaurdId
        StartDateTime
        Title
        created_at
        updated_at
        Shift_Gaurd {
          Gaurd {
            GaurdFirstName
          }
        }
      }
    }

          `
          })
          .then(result => console.log("The result issss", result));
    */

//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////TESTING THE CLIENT//////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////








    console.log("object");
    if (this.state.shiftId === 0) {
      return <div>...Loading</div>;
    }
    // Logic to determine which template to set
    else if (this.state.template == 1) {
      return (
        <ApolloProvider client={client}>
          <Grommet>
            <Box>
              <Report
                runningLocally={this.state.runningLocally}
                shiftId={this.state.shiftId}
                lobi={this.state.lobi}
                shiftStartDate={this.state.shiftStartDate}
              ></Report>
            </Box>
          </Grommet>
        </ApolloProvider>
      );
    }
    // Logic to determine which template to set
    else if (this.state.template == 2) {
      return (
        <ApolloProvider client={client}>
          <Report_template_2 buildingId={this.state.buildingId} >
          </Report_template_2>
        </ApolloProvider>
      )
    }
    else if (this.state.template == 3) {
      return (
        <ApolloProvider client={client}>
          <Report_template_2 buildingId={this.state.buildingId} >
          </Report_template_2>
        </ApolloProvider>
      )
    } else {
      return (
        <body>
          <h1>Please enter a supported template in URL. </h1>
          <h2>i.e. http://localhost:3000/?templateID </h2>
          <h3>Template 1 (Daily Shift Report) format : http://localhost:3000/?1?shiftId, e.g. <a href="http://localhost:3000/?1?4937">http://localhost:3000/?1?4937</a>, note: add: <a href="http://localhost:3000/?1?4937?lobi">http://localhost:3000/?1?4937?lobi </a> to see include lobi in reports </h3>
          <h3>Template 2 (Cumulative unresolved Incident Report) format : http://localhost:3000/?2?buildingId , e.g.  <a href="http://localhost:3000/?2?178ffda8-f1a2-4fce-878b-24a191138269">http://localhost:3000/?2?178ffda8-f1a2-4fce-878b-24a191138269</a>  </h3>
        </body>
      )
    }
  }
}

export default App;
